/**
 * Tiny cross-component control for the support chat panel. The panel's
 * open/closed state lives as local state inside `SupportChatBridge` (mounted
 * once, app-wide). There is no context/provider, so any component that wants to
 * open the panel dispatches this event and the mounted bridge listens for it.
 */
const OPEN_SUPPORT_CHAT_EVENT = "fiscalo:open-support-chat";

/** Open the support chat panel from anywhere in the app. */
export function openSupportChat(): void {
  window.dispatchEvent(new CustomEvent(OPEN_SUPPORT_CHAT_EVENT));
}

/**
 * Subscribe the mounted `SupportChatBridge` to programmatic open requests.
 * Returns an unsubscribe function for effect cleanup.
 */
export function subscribeOpenSupportChat(handler: () => void): () => void {
  window.addEventListener(OPEN_SUPPORT_CHAT_EVENT, handler);
  return () => window.removeEventListener(OPEN_SUPPORT_CHAT_EVENT, handler);
}
